export default {
  items: [
    {
      title: true,
      name: 'Track',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Time',
      url: '/time',
      icon: 'icon-clock'
    },
    /*{
      name: 'Materials',
      url: '/materials',
      icon: 'icon-puzzle'
    },*/
    {
      name: 'Expense',
      url: '/expense',
      icon: 'icon-credit-card'
    },
    {
      title: true,
      name: 'Manage',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Projects',
      url: '/projects',
      icon: 'icon-briefcase'
    },
    {
      name: 'Employees',
      url: '/employees',
      icon: 'icon-people'
    },
    {
      title: true,
      name: 'Reports',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    /*{
      name: 'Business',
      url: '/business',
      icon: 'icon-graph'
    },*/
    {
      name: 'Portfolio',
      url: '/portfolio',
      icon: 'icon-folder'
    },
    {
      name: 'Project Reports',
      url: '/project-reports',
      icon: 'icon-docs'
    },
    {
      name: 'Time Reports',
      url: '/time-reports',
      icon: 'icon-list'
    }
  ]
}
